var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"size":"mini","border":"","resizable":"","auto-resize":"","highlight-hover-row":"","loading":_vm.loading,"data":_vm.tableData,"columns":_vm.tableColumns},scopedSlots:_vm._u([{key:"containerAmount",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.containerPriceAmount)+_vm._s(row.v_currencyUnit))])]}},{key:"containerSalePrice",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(" "+_vm._s(row.containerSalePriceAmout)+_vm._s(row.v_salesCurrencyUnit)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }